import React from 'react';

const ProductActionButtons = ({ 
    onOpenModal, 
    onDeleteSelected, 
    selectedCount 
}) => {
    return (
        <div className="flex gap-2 md:gap-3">
            {/* 데스크톱 버튼들 */}
            <div className="hidden md:flex gap-3">
                <button 
                    onClick={() => onOpenModal('케이타운')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#2962CC] focus:bg-[#2962CC] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    +케이타운
                </button>
                <button 
                    onClick={() => onOpenModal('위버스')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#02CBD5] focus:bg-[#02CBD5] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    + 위버스
                </button>
                <button 
                    onClick={() => onOpenModal('올리브영')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#9BCE26] focus:bg-[#9BCE26] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    + 올리브영
                </button>
                <button 
                    onClick={() => onOpenModal('무신사')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#111113] focus:bg-[#111113] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    + 무신사
                </button>
                <button 
                    onClick={() => onOpenModal('다이소')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#D70211] focus:bg-[#D70211] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    + 다이소
                </button>
                <button 
                    onClick={() => onOpenModal('국립박물관')}
                    className="h-[30px] bg-slate-500/60 hover:bg-[#874D3C] focus:bg-[#D70211] text-white px-4 py-2 rounded text-xs font-medium transition-colors w-21"
                >
                    + 국립박물관
                </button>
                <button 
                    onClick={onDeleteSelected}
                    disabled={selectedCount === 0}
                    className="h-[30px] bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-4 py-2 rounded text-xs font-medium transition-colors"
                >
                    삭제
                </button>
            </div>

            {/* 750px 초과 모바일 버튼들 */}
            <div className="mobile:hidden md:hidden flex gap-2">
                <button 
                    onClick={() => onOpenModal('케이타운')}
                    className="h-7 bg-slate-500/60 hover:bg-[#02CBD5] focus:bg-[#02CBD5] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +케이타운
                </button>
                <button 
                    onClick={() => onOpenModal('위버스')}
                    className="h-7 bg-slate-500/60 hover:bg-[#02CBD5] focus:bg-[#02CBD5] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +위버스
                </button>
                <button 
                    onClick={() => onOpenModal('올리브영')}
                    className="h-7 bg-slate-500/60 hover:bg-[#9BCE26] focus:bg-[#9BCE26] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +올리브영
                </button>
                <button 
                    onClick={() => onOpenModal('무신사')}
                    className="h-7 bg-slate-500/60 hover:bg-[#111113] focus:bg-[#111113] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +무신사
                </button>
                <button 
                    onClick={() => onOpenModal('다이소')}
                    className="h-7 bg-slate-500/60 hover:bg-[#D70211] focus:bg-[#D70211] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +다이소
                </button>
                <button 
                    onClick={() => onOpenModal('국립박물관')}
                    className="h-7 bg-slate-500/60 hover:bg-[#D70211] focus:bg-[#D70211] text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    +국립박물관
                </button>
                <button 
                    onClick={onDeleteSelected}
                    disabled={selectedCount === 0}
                    className="h-7 bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    삭제
                </button>
            </div>

            {/* 510px 이하 모바일 - 상품 추가 버튼만 */}
            <div className="mobile:flex hidden md:hidden gap-2">
                <button 
                    onClick={() => onOpenModal(null)}
                    className="h-7 bg-slate-500/60 hover:bg-slate-700 text-white px-4 py-1 rounded text-xs font-medium transition-colors"
                >
                    상품 추가
                </button>
                <button 
                    onClick={onDeleteSelected}
                    disabled={selectedCount === 0}
                    className="h-7 bg-red-500 hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-2 py-1 rounded text-xs font-medium transition-colors"
                >
                    삭제
                </button>
            </div>
        </div>
    );
};

export default ProductActionButtons;
